import Home from './../views/Home'
import Welcome from './../views/Welcome'
import UserRegister from './../views/user/Register'
import UserFolderRequests from './../views/user/products/Requests'
import UserNotifications from './../views/user/Notifications'

// Middleware
import {middlewareUserAuth, middlewareUserNotConnect, middlewareUserHome} from './../../default/router/Middlewares'

var routes = {
    list: [ 
        { path: '/bienvenue', component: Welcome, name: 'welcome', beforeEnter: middlewareUserNotConnect},
        { path: '/', component: Home, name: 'home', beforeEnter: middlewareUserHome},
        { path: '/utilisateur/inscription', component: UserRegister, name: 'user.login.actors'},
        { path: '/utilisateur/notifications', component: UserNotifications, name: 'user.notifications', beforeEnter: middlewareUserAuth},
        { path:  '/utilisateur/dossier/demandes-sav', component: UserFolderRequests, name: 'user.folder.requests', beforeEnter: middlewareUserAuth},
    ],
}

export default routes



// WEBPACK FOOTER //
// ./src/companies/casino/router/routes.js